'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Vue = require('vue');
var vuex = require('vuex');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', {
    get: function () {
      return 7;
    }
  }).a != 7;
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var document$2 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$2) && _isObject(document$2.createElement);
var _domCreate = function (it) {
  return is ? document$2.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', {
    get: function () {
      return 7;
    }
  }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP$2 = Object.defineProperty;
var f$6 = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP$2(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f$6
};

var dP$1 = _objectDp.f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || _descriptors && dP$1(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

var hasOwnProperty$4 = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty$4.call(it, key);
};

var toString$2 = {}.toString;
var _cof = function (it) {
  return toString$2.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min$1 = Math.min;
var _toLength = function (it) {
  return it > 0 ? min$1(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};

var _core = createCommonjsModule(function (module) {
var core = module.exports = {
  version: '2.6.12'
};
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
_core.version;

var _library = false;

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});
(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode: 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO$1 = _sharedKey('IE_PROTO');
var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO$1) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)


var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var _functionToString = _shared('native-function-to-string', Function.toString);

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');

var TO_STRING = 'toString';
var TPL = ('' + _functionToString).split(TO_STRING);
_core.inspectSource = function (it) {
  return _functionToString.call(it);
};
(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || _functionToString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function /* ...args */
  () {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE$2 = 'prototype';
var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE$2];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE$2] || (exports[PROTOTYPE$2] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () {
    fn(1);
  }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)


_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var _meta = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, {
    value: {
      i: 'O' + ++id,
      // object ID
      w: {} // weak collections IDs
    }
  });
};

var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }
  return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }
  return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
_meta.KEY;
_meta.NEED;
_meta.fastKey;
_meta.getWeak;
_meta.onFreeze;

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';
var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};
$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');
var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
    configurable: true,
    value: tag
  });
};

var f$5 = _wks;

var _wksExt = {
	f: f$5
};

var defineProperty$1 = _objectDp.f;
var _wksDefine = function (name) {
  var $Symbol = _core.Symbol || (_core.Symbol = _global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$1($Symbol, name, {
    value: _wksExt.f(name)
  });
};

var f$4 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$4
};

var f$3 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$3
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys(it);
  var getSymbols = _objectGops.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  }
  return result;
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$1 = _global.document;
var _html = document$1 && document$1.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO = _sharedKey('IE_PROTO');
var Empty = function () {/* empty */};
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};
var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');
var f$2 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$2
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN$1 = _objectGopn.f;
var toString$1 = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function (it) {
  try {
    return gOPN$1(it);
  } catch (e) {
    return windowNames.slice();
  }
};
var f$1 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN$1(_toIobject(it));
};

var _objectGopnExt = {
	f: f$1
};

var gOPD$1 = Object.getOwnPropertyDescriptor;
var f = _descriptors ? gOPD$1 : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD$1(O, P);
  } catch (e) {/* empty */}
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;





















var gOPD = _objectGopd.f;
var dP = _objectDp.f;
var gOPN = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = _wks('_hidden');
var TO_PRIMITIVE = _wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = _shared('symbol-registry');
var AllSymbols = _shared('symbols');
var OPSymbols = _shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops.f;
var QObject = _global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP({}, 'a', {
    get: function () {
      return dP(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;
var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};
var isSymbol$1 = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};
var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  _anObject(it);
  key = _toPrimitive(key, true);
  _anObject(D);
  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, {
        enumerable: _propertyDesc(0, false)
      });
    }
    return setSymbolDesc(it, key, D);
  }
  return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject(it);
  var keys = _enumKeys(P = _toIobject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor$1 = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(_toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }
  return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }
  return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };
    if (_descriptors && setter) setSymbolDesc(ObjectProto, tag, {
      configurable: true,
      set: $set
    });
    return wrap(tag);
  };
  _redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });
  _objectGopd.f = $getOwnPropertyDescriptor$1;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;
  if (_descriptors && !_library) {
    _redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }
  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}
_export(_export.G + _export.W + _export.F * !USE_NATIVE, {
  Symbol: $Symbol
});
for (var es6Symbols =
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) _wks(es6Symbols[j++]);
for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);
_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol$1(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () {
    setter = true;
  },
  useSimple: function () {
    setter = false;
  }
});
_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$1,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = _fails(function () {
  _objectGops.f(1);
});
_export(_export.S + _export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return _objectGops.f(_toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({
    a: S
  }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol$1(it)) return; // IE8 returns string on undefined
    if (!_isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol$1(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag(_global.JSON, 'JSON', true);

var SPECIES = _wks('species');
var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }
  return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)

var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res; // map
        else if (res) switch (TYPE) {
          case 3:
            return true;
          // some
          case 5:
            return val;
          // find
          case 6:
            return index;
          // findIndex
          case 2:
            result.push(val);
          // filter
        } else if (IS_EVERY) return false; // every
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

var _strictMethod = function (method, arg) {
  return !!method && _fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () {/* empty */}, 1) : method.call(null);
  });
};

var $filter = _arrayMethods(2);
_export(_export.P + _export.F * !_strictMethod([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $getOwnPropertyDescriptor = _objectGopd.f;
_objectSap('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(_toIobject(it), key);
  };
});

// all object keys, includes non-enumerable and symbols



var Reflect = _global.Reflect;
var _ownKeys = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = _objectGopn.f(_anObject(it));
  var getSymbols = _objectGops.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));else object[index] = value;
};

// https://github.com/tc39/proposal-object-getownpropertydescriptors





_export(_export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = _toIobject(object);
    var getDesc = _objectGopd.f;
    var keys = _ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) _createProperty(result, key, desc);
    }
    return result;
  }
});

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(_typeof_1);

var toPrimitive = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(toPrimitive);

var toPropertyKey = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];

function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(toPropertyKey);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _defineProperty = unwrapExports(defineProperty);

var regeneratorRuntime$1 = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function _regeneratorRuntime() {

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(regeneratorRuntime$1);

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntime$1();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

var drag = {
  bind: function bind(el) {},
  inserted: function inserted(el) {
    el.onmousedown = function (e) {
      var distanceX = e.pageX - el.offsetLeft;
      var distanceY = e.pageY - el.offsetTop;
      var minMoveX = 0 - el.clientWidth / 2;
      var maxMoveX = document.querySelector('html').clientWidth - el.clientWidth + 150;
      var minMoveY = 0 - 150;
      var maxMoveY = document.querySelector('html').clientHeight - el.clientHeight / 2;
      document.onmousemove = function (e) {
        var moveX = e.pageX - distanceX;
        var moveY = e.pageY - distanceY;
        if (minMoveX < moveX && moveX < maxMoveX) el.style.left = moveX + 'px';
        if (minMoveY < moveY && moveY < maxMoveY) el.style.top = moveY + 'px';
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
        el.style.cursor = 'default';
      };
    };
  },
  updated: function updated(el) {}
};

// import * as Telescope from '@zyf2e/telescope';

// main.js引入
var Directive = {
  install: function install(Vue) {
    // 埋点
    // Vue.directive('track-event', Telescope.vTrackEvent);
    // Vue.directive('track-page', Telescope.vTrackPage);
    // 权限
    // Vue.directive('permission', permission);
    // 拖拽
    Vue.directive('drag', drag);
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
Vue__default["default"].use(Directive);
var script$2 = {
  name: 'rtcVideo',
  components: {},
  computed: _objectSpread$2(_objectSpread$2({}, vuex.mapGetters({
    isCaller: 'video_appearanceStore/getIsCaller',
    beBusy: 'video_appearanceStore/getBeBusy',
    videoInfo: 'video_appearanceStore/getVideoInfo',
    videoService: 'video_controller/getVideoService',
    boxStatus: 'video_appearanceStore/getBoxStatus'
  })), {}, {
    callDurationStr: function callDurationStr() {
      var time = this.videoInfo.time;
      return time;
    }
  }),
  mounted: function mounted() {
    this.$store.commit('video_trtcVideoStore/SET_PC_VIDEOBOX', this);
  },
  methods: {
    handlerCancel: function handlerCancel() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              /**
               * @description 用户取消
               */
              _this.$store.dispatch('video_trtcVideoStore/cancelCall');
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handlerHangupCaller: function handlerHangupCaller() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              /**
               * @description 用户挂断
               */
              _this2.$store.dispatch('video_trtcVideoStore/hangupCall', true);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handlerHangup: function handlerHangup() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              /**
               * @description 用户挂断
               */
              _this3.$store.dispatch('video_trtcVideoStore/hangupCall');
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handlerReject: function handlerReject(msg) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              /**
               * @description 拒接
               */
              _this4.$store.dispatch('video_trtcVideoStore/rejectCall');
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    handlerAccepted: function handlerAccepted() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              /**
               * @description 接听
               */
              _this5.$store.dispatch('video_trtcVideoStore/acceptCall');
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  }
};

var img$5 = "data:image/png;base64,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";

var img$4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAMJklEQVR4Xu1de3BU1Rn/fXfzIKshCeGhlqERxIAv3lQBrWB2AwpRR5HRTXgqdlod1Foe1veDAeqgdtQqSgp5VNHqKKBkNwxUiAwNICAVSbWCSKkIAeKSTUKy+3XOhoXdkOy9d+9jN8neP/d+79+ee8/9zne+Q4jRK69iZmqdpzGbmLOZkQ0gG4TeDE4lRioTpRJzqjCfidzE7GaCm0BuMA4BqCJCFRNVpVgTq1aPKXTHoqsUK0ZN2Oro6q2x3OCDbxyBxzIwCAx97CMwAbsZtFGCtMGS5t207trSn2PBd30cjNCTnPLZacSeyWAuAGM0A5YIRaliI8ALwucgKmayvr/etqxGlQAdiU0HgJnJXj51Anw8jQl5YO6ioz/qRRHVE2M1JFrpshWtIyJWLyRyDtMAmMzvWU44104heB9j4MrITTaOk4CvGJaFGbkTV71Pd3mN03ROsuEAiMDXuNZMZ/B8Zr7MDKe06iCibwm0KM0+aYXRQBgKgN2ZP4qB15l5kNagRIOfiHYT8FtXbskWo/QbAsCkjbO7152uWwz4Zug2kzEqAnJyCQxIf01JSpm3ZuyyY3Lkau/rDkBu+dRbfT5vITO6qTUmpumJqi2SNMtpK/pYTzt1A2D29tmJ31V7FoP5YT0NjDlZRC/1zbTOWzZ8WaMetukCwPiN07O8pxtXMWOkHkbFugwiVFqSEqeUjV1xQKutmgEYv94xoqkJnwLortWYdsZ/LCEBN5fllG7TYrcmAGwuh50ZH4BxoRYj2i0v4RQR7ii3l7oi9SFiAGyu/LuZsRLMiZEq7xB8RI1EmFZuL3knEn8iAqA5+Fza7qeYkUSsNR6R7CNyRAKCagCaHzu0ttP/81sC4R8JPFHt40gVAP4XrhcbOu0zX27EEE4lWDBOzYtZMQBiqtnU0Cje+J1ttiMX9pb3jyUkJ45QOkVVBID4yNpfXVvRWeb5aiN+/tMIlZdmXjBGyceaIgDszoKXfOx7SKthnYlfIullV26xbFZAFgCR2/F6vR91puDp5avFYrlNLncUFgCR1aw/XVvV4RJrekVYTg5RdUqSdUC4LGpYAHKcBcvBvplyeuL3w0SApML1ucWz2qJoEwCxmOIDV8Q/tjT+vQgsgca0tajTKgBiGfGka/WO9rqSpTFkurOLlbV0e96w1pY3WwXA7iyY5WPf27pb0okFSiTd68otXn7elLXlD2f+/fvaywJ6e8FULPSn2/MGtBwF542AnLKp9wDeUjMd65XSAzP634nhmdeg3luPip+2o+jbD+FpqjPTDBN0WRzrxxf9LVhRCAD+oiln/h4z63ZG9hiMJwY9iC6W5JAAHK2vxrzti/FD7WETAmOOClF35MotuTq4+CsEAJur4Gb2+T4xxxzgup5D8dTgObBQ6xWJAoQHtj6J4w1RqxzUPRQkSbeU24vFCqL/CgWgLH8Vg+/SXWsrAgd1G4iFw+YiSQq/nvNF9b8wf/tisKgO6QAXgd4rH18y5TwARKEsfJ4fzajVzEhKw4rrX4Q1IUVRSF/9eiU+PliuiDbmiYjqIVkvChQEnx0BNlf+vezjt8xw4IGB03BrH5tiVZ6mehRsegg/N55SzBPLhCTRfeX2Ev80/xwATsdnzLjBDMPfHLUQfVP7qFL1znerUfjNe6p4YpWYCJvKc0t/fRYAsTmi6SSOm1Wf//FNbyl+/ASC+F/Pj5i++dFYjakqu8T+hIR0dBObRPwjwO6cOtHH3jWqpGgg/uimZbggwapawgTXNDSxKVXjqm1TyyCRZZIrt2itH4AcZ/5SM0sK3xq9CFkX9lZl86nGWty+4X5VPDFNTPTS+tySR/wA2Jz5u8xMvL0w7A8Y2V1dxfrfD3yKN6tCPiJjOr5yxhFhV3lu6RASuxE9tQ01Zqad7+6bh5n9lX9ufOc+iDn/fAb13gY5v9rPfQJbL0hOI5urYDj7fJrqG9V63S/1l3hj1AuK2A57juDhymc71NdwwHGSpBEi9+PwMZcoioZORATCuze+im7JaWElNvmaMLNiLv5X95NOmmNLjESUT7ay/GcZ/ITZpt2ffQ/uzLo5rNrdx7/Go9uUjRSz7ddDH4GeEwCYlv8JNlqkoIuvXwqitpelD9YexqyKuXr4GpMyRF6IcsocYgPaddGw8OkhD2N0z2FhVc/esgD73T9EwzzDdRLRFspxOr4E42rDtbWi4OqMAVg68vGwqiuObMMzu16JhnnG6yTsIVuZYz8DWcZra13Dc0MfwbU9hoZV/8cdf0Llsd3RMtEwvQQcoBxn/jEwZxqmRUbwL6wX4e3Ri5AgJbRJWd1wAvdveQw1p2Oy4UnkoSOqFiOggYGkyKVo51QyI9pRvQcLdiwBc8dYmBFRI+B0TAAgEnPLxyxGZnJGWDQ7XDpCABDtR1Ag4oO7XYElwxeEnZYK2j/vXYE1P6zXPuxiQcKZR1BUX8LBcRD5IZEnCnf52Icndi5F5dFdsRBCTTaceQlHbxra0npRHfHyr57EgLR+YR2r89ZjwfbF+OrkN5oCEHVm/zTUmf85M4+KujFnDLg4pSdeu+5ZpCaG33osQBDT0z0nqmLFdNV2+D/EopWKCGftlemXY8mIBbIlKyI9/fgXL0LkjNrj5U9FRCsZJxew0b2G46lBc2Rfyg3e03h+96vYevSLsCJFzun6XiNxTcYAf8nj1qM7sTfKjzB/Mi4a6Wi54Afu5/Wx4cGB02TJxbfBG1Wl+PD7slZpxTRXVOANyQztlCaKvv6yrwQHTokul+ZfzenoKCzIqHFVycwoIG/zkW14ZW9hyBezNaELFg2bj4HprXdLEyPo9X3F+PTQRjVm6ULrX5CJxpKkWutn9J+Me/reqojN3XgKq/Z/gs1HKv3vkN9fdZ/srEoI/uigC699XaRIhy5EgSVJIczmdOxkxmBdBBskxNHvNky/7E6DpDeLfXf/Giz/9ypDdQSEn12UFz+YXZYSqYeTs27B7Oy7I2VXxPdI5fPYc2KfIlpNRMFlKWYXZmkxPK9PDn43YCokkrSIaZNXvJjnbV9kiOxgoSGFWWaXJmr1TuSNHh/0INKS/L27db1EAfAdG36jq8yWws4rTTzzHjCtOFcP73p2ycTTQx5C/66X6iHurIyf6qvh+GyOrjLPA6Blca4fABPL0/XyTsxyRKn7hN436iXSn2kVGVcjr1bL083coKG3c0Mzr8KcK2bgEmsvTaJrmzz+OqTjDSc1yQnL3NYGDf8oiFKJih7eJluSUNDvdn+tUVt7zsLpEV/TT+5c6k9RGHm1uUWp+TFk7iY9IxwVa8xTLp0I2yVjwq4zB+sW+89e3LMMrsObjTApRGbYTXrR2KZqlMc9unTzj4abLh6FtKSubaoRCzwv7y3EukP/MMqUs3Jlt6kKymhs1DbSc5EFvSr9cozqORz9u2bhopTuyEhOh6i0OOA+hJXffoD/uL830oQg2TIbtQVlvFWBMVgoblUg1MebdegPguJmHUGjIN6uRiccVLeraR4F8YZNusQ/koZNAcXxlmU6QBBpyzKhuvkoEs++aNaO6hCC6InQ2rRPWB5vWxk5fprbVgZUxxu3RgDCmQUXOU7Zxq1CQLx1sVwYQ++LI050bV0sxMebdysGQf/m3QHV8fb1MiAY2b4+oDp+gEMbIJhxgMM5EOJHmITAYOYRJqEgxA/xQTQO8Ql9HMWPsVJ7bkzw6FE0DQ336okf5BbFg9zOzo7iRxkqnqO2JNQ8AgICxcfageq6JR39qBNxNElWZspcJefDKEFFNwACyuLH2SoJ+zka3QE4l0WNH+isBApDADiXxIsfaS4HgqEACOVikb/GtWY6g+e3lzMJxAI6gRal2SetaO3UC7mgqrlvOAABYwQQJ5xrpxC8j5nZHl9lML5iWBZm5E5cZXTgA3aZBkBAob/4q3zqBPh4GhPyzGgWHhYEonpirIZEK122onXBvf3VgBcprekABBsqCoKJPZPBXADGaLNaJ4v6fBA+B1Exk/X9QCfzSIOohS+qAAQbLjaJeGssN/jgG0fAOAZfo1svU5EsA33JwAYJ0gZLmneT6NusJXB68cYMAC0dErs36zyN2cSczYxsANkg9GZwKjFSmSiVmP1bZJjITcxuJrgJ5AZDbPytIkIVE1WlWBOrVo8pjMluT/8HkQ33EXaZL+YAAAAASUVORK5CYII=";

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  }
  // Vue.extend constructor export interop.
  const options = typeof script === 'function' ? script.options : script;
  // render functions
  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true;
    // functional template
    if (isFunctionalTemplate) {
      options.functional = true;
    }
  }
  // scopedId
  if (scopeId) {
    options._scopeId = scopeId;
  }
  let hook;
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context = context ||
      // cached call
      this.$vnode && this.$vnode.ssrContext ||
      // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      }
      // inject component styles
      if (style) {
        style.call(this, createInjectorSSR(context));
      }
      // register component module identifier for async chunk inference
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }
  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      const originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      const existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return script;
}

/* script */
const __vue_script__$2 = script$2;
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.boxStatus.visible
    ? _c(
        "div",
        {
          directives: [{ name: "drag", rawName: "v-drag" }],
          staticClass: "video-box-wrapper",
        },
        [
          _c(
            "div",
            {
              class: [
                _vm.beBusy
                  ? "video-service-container"
                  : "video-service-remoteContainer",
              ],
              attrs: { id: "localContainerTRTC" },
            },
            [_vm.isCaller ? [_vm._m(0)] : [_vm._m(1)]],
            2
          ),
          _vm._v(" "),
          _c("div", {
            class: [
              !_vm.beBusy
                ? "video-service-container"
                : "video-service-remoteContainer",
            ],
            attrs: { id: "remoteContainerTRTC" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "call-duration" }, [
            _vm._v(_vm._s(_vm.callDurationStr)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "video-operate" },
            [
              _vm.isCaller
                ? [
                    _vm.beBusy
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "operate-box reject",
                              on: { click: _vm.handlerHangupCaller },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$5,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("挂断")]),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "operate-box reject",
                              on: { click: _vm.handlerCancel },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$5,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("取消")]),
                            ]
                          ),
                        ],
                  ]
                : [
                    _vm.beBusy
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "operate-box reject",
                              on: { click: _vm.handlerHangup },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$5,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("挂断")]),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "operate-box reject",
                              on: { click: _vm.handlerReject },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$5,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("拒绝")]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "operate-box answer",
                              on: { click: _vm.handlerAccepted },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$4,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("接听")]),
                            ]
                          ),
                        ],
                  ],
            ],
            2
          ),
        ]
      )
    : _vm._e()
};
var __vue_staticRenderFns__$2 = [
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "video-waiting" }, [
      _c("p", { staticClass: "tip-text" }, [
        _vm._v("\n          呼叫中\n          "),
        _c("span", { staticClass: "dotting" }),
      ]),
    ])
  },
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "video-waiting" }, [
      _c("p", { staticClass: "tip-text" }, [
        _vm._v("\n          接听中\n          "),
        _c("span", { staticClass: "dotting" }),
      ]),
    ])
  },
];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = "data-v-1ae35529";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__$2.install = function (Vue) {
  Vue.component(__vue_component__$2.name, __vue_component__$2);
};

var img$3 = "data:image/png;base64,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";

var img$2 = "data:image/png;base64,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";

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAABPUlEQVQoU42SvUuCURTGn+dKmAYWQQVtTUFb0BQEDQlFa6/2sTQFpg4NEbSYSxQ0BUUfY9CgY1FtRdAcLTXYHxAYhYHXeBOfMAp8RbS7Pr/zO+dwLvGPJ8fxYShPpm/KrXDWArnklL+/EpokNC5gBMAAgV4Bbb+cS+ANwDOABxDXAbd0yaMz++f5ESqVMvb1aR3ECoTuVlPU5QUKx4Ggf4M7J0VW17F9vIIw0UBUAZCHUCJJQZ0Auho2JB4BE2YxHl0CdFgHvRhhvr1Hd0xn3dpMyYXQZ9kdljGbgka9dTqnjUfWBGzVCS869jLTzVa3iagjKeNpRuZolyNzIk5rAyMcBPYzsWbCj9jMmM+YWw8j3VMAS4noLqSwhPfq5YJf2uZRttDqODburApchDBIwhpg1vNtWgma5dXBCOgbPO9xWxnZsIoAAAAASUVORK5CYII=";

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$1 = {
  name: 'NERTCV1Box',
  components: {},
  data: function data() {
    return {
      img: {
        video_expand: img$3,
        video_shrink: img$2,
        video_reject: img$5,
        video_answer: img$4,
        shrink_video_icon: img$1
      }
    };
  },
  computed: _objectSpread$1(_objectSpread$1({}, vuex.mapGetters({
    isCaller: 'video_appearanceStore/getIsCaller',
    beBusy: 'video_appearanceStore/getBeBusy',
    videoService: 'video_controller/getVideoService',
    videoInfo: 'video_appearanceStore/getVideoInfo',
    show: 'video_nertcv1/getShow'
  })), {}, {
    callDurationStr: function callDurationStr() {
      var time = this.videoInfo.time;
      return time;
    }
  }),
  methods: {
    reject: function reject() {
      this.$store.dispatch('video_nertcv1/reject');
    },
    hangupByCaller: function hangupByCaller() {
      this.$store.dispatch('video_nertcv1/hangupByCaller');
      this.$store.dispatch('video_controller/message', {
        message: '您已挂断通话'
      });
    },
    hangup: function hangup() {
      this.$store.dispatch('video_nertcv1/hangup');
    },
    cancle: function cancle() {
      this.$store.dispatch('video_nertcv1/cancle');
    },
    accepted: function accepted() {
      this.$store.dispatch('video_nertcv1/accepted');
    },
    zoom: function zoom() {
      this.$store.commit('video_nertcv1/SET_WEBRTC_STATUS_nertc', {
        key: 'shrink',
        value: !this.shrink
      });
    },
    videoHandler: function videoHandler() {
      if (this.shrink) this.$emit('zoom');
    },
    toPicture: function toPicture() {
      this.$emit('reject');
      this.$player.$emit('applyPrescription', 2);
    }
  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.show
    ? _c(
        "div",
        {
          directives: [{ name: "drag", rawName: "v-drag" }],
          staticClass: "video-modal-wrapper",
        },
        [
          _c("transition", { attrs: { name: "video-box-fade" } }, [
            _c("div", { staticClass: "video-box-wrapper" }, [
              _c("div", {
                class: [_vm.beBusy ? "remoteContainer" : "container"],
                attrs: { id: "container" },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [_vm.beBusy ? "container" : "remoteContainer"],
                  attrs: { id: "remoteContainer" },
                },
                [
                  _vm.isCaller
                    ? [
                        _c("div", { staticClass: "video-waiting" }, [
                          _c("p", { staticClass: "tip-text" }, [
                            _vm._v("\n              呼叫中\n              "),
                            _c("span", { staticClass: "dotting" }),
                          ]),
                        ]),
                      ]
                    : [
                        _c("div", { staticClass: "video-waiting" }, [
                          _c("p", { staticClass: "tip-text" }, [
                            _vm._v("\n              接听中\n              "),
                            _c("span", { staticClass: "dotting" }),
                          ]),
                        ]),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "call-duration" }, [
                _vm._v(_vm._s(_vm.callDurationStr)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "video-operate" },
                [
                  _vm.isCaller
                    ? [
                        _vm.beBusy
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "operate-box reject",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation();
                                      return _vm.hangupByCaller.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img",
                                    attrs: {
                                      src: _vm.img.video_reject,
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("挂断")]),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticClass: "operate-box reject",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation();
                                      return _vm.cancle.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img",
                                    attrs: {
                                      src: _vm.img.video_reject,
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("取消")]),
                                ]
                              ),
                            ],
                      ]
                    : [
                        _vm.beBusy
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "operate-box reject",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation();
                                      return _vm.hangup.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img",
                                    attrs: {
                                      src: _vm.img.video_reject,
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("挂断")]),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticClass: "operate-box reject",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation();
                                      return _vm.reject.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img",
                                    attrs: {
                                      src: _vm.img.video_reject,
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("拒绝")]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "operate-box answer",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation();
                                      return _vm.accepted.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img",
                                    attrs: {
                                      src: _vm.img.video_answer,
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("接听")]),
                                ]
                              ),
                            ],
                      ],
                ],
                2
              ),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = "data-v-6ef8a1dc";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__$1.install = function (Vue) {
  Vue.component(__vue_component__$1.name, __vue_component__$1);
};

// 19.1.2.1 Object.assign(target, source, ...)






var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
    }
  }
  return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)

_export(_export.S + _export.F, 'Object', {
  assign: _objectAssign
});

var classnames = createCommonjsModule(function (module) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

  var hasOwn = {}.hasOwnProperty;
  function classNames() {
    var classes = [];
    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (!arg) continue;
      var argType = typeof arg;
      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg)) {
        if (arg.length) {
          var inner = classNames.apply(null, arg);
          if (inner) {
            classes.push(inner);
          }
        }
      } else if (argType === 'object') {
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
          classes.push(arg.toString());
          continue;
        }
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      }
    }
    return classes.join(' ');
  }
  if (module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else {
    window.classNames = classNames;
  }
})();
});

var img = "data:image/png;base64,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";

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray_1 = isArray;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$3.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$3.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
}
var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}
var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}
var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}
var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}
var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');
var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}
var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}
var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');
var _Map = Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}
var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}
var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}
var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function () {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;
var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}
var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}
var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}
var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}
var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}
var get_1 = get;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
Vue__default["default"].use(Directive);
var script = {
  name: 'rtcVideo',
  data: function data() {
    return {
      beBusyWindow: 'localContainer',
      nowChannel: ''
    };
  },
  mounted: function mounted() {
    this.watchChannel();
  },
  components: {},
  computed: _objectSpread(_objectSpread({}, vuex.mapGetters({
    videoService: 'video_controller/getVideoService',
    visible: 'video_rtcui/getVisible',
    beBusy: 'video_rtcui/getIsBusy',
    videoInfo: 'video_rtcui/getVideoInfo',
    isCaller: 'video_rtcui/getIsCaller',
    shrink: 'video_rtcui/getShrink'
  })), {}, {
    callDurationStr: function callDurationStr() {
      var time = this.videoInfo.time;
      return time;
    },
    localContainerClass: function localContainerClass() {
      var beBusy = this.beBusy,
        nowChannel = this.nowChannel,
        shrink = this.shrink,
        beBusyWindow = this.beBusyWindow;
      var cls = _defineProperty({}, "rtc__".concat(nowChannel), true);
      if (!shrink) {
        if (!beBusy) {
          Object.assign(cls, {
            videoContainerSmall: true
          });
        } else {
          Object.assign(cls, {
            videoContainerBig: beBusyWindow == 'localContainer',
            videoContainerSmall: beBusyWindow != 'localContainer'
          });
        }
      } else {
        Object.assign(cls, {
          null_container: true
        });
      }
      return classnames(cls);
    },
    remoteContainerClass: function remoteContainerClass() {
      var beBusy = this.beBusy,
        nowChannel = this.nowChannel,
        shrink = this.shrink,
        beBusyWindow = this.beBusyWindow;
      var cls = _defineProperty({}, "rtc__".concat(nowChannel), true);
      if (!shrink) {
        if (!beBusy) {
          Object.assign(cls, {
            videoContainerBig: true
          });
        } else {
          Object.assign(cls, {
            videoContainerBig: beBusyWindow == 'remoteContainer',
            videoContainerSmall: beBusyWindow != 'remoteContainer'
          });
        }
      } else {
        Object.assign(cls, {
          videoContainerBig: true
        });
      }
      return classnames(cls);
    },
    shrinkIcon: function shrinkIcon() {
      if (this.shrink) {
        return img$3;
      }
      return img$2;
    },
    changeRemoteIcon: function changeRemoteIcon() {
      return img;
    },
    video_box_wrapper: function video_box_wrapper() {
      return classnames({
        'video-box-wrapper': true,
        zoom: this.shrink
      });
    },
    videoOperate: function videoOperate() {
      return classnames({
        'video-operate': true
      });
    }
  }),
  methods: {
    watchChannel: function watchChannel() {
      var _this = this;
      setTimeout(function () {
        var state = _this.$store.state;
        if (get_1(state.video_controller.zyRtcInitData, 'sdkLib.videoService.ele.channel')) {
          var c = state.video_controller.zyRtcInitData.sdkLib.videoService.ele.channel;
          _this.nowChannel = c;
        }
        _this.watchChannel();
      }, 5000);
    },
    changeRemote: function changeRemote() {
      if (this.beBusyWindow == 'localContainer') {
        this.beBusyWindow = 'remoteContainer';
      } else {
        this.beBusyWindow = 'localContainer';
      }
      this.$store.dispatch('video_rtcui/changeRemote');
    },
    zoom: function zoom() {
      this.$store.dispatch('video_rtcui/setShrink');
    },
    handlerCancel: function handlerCancel() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              /**
               * @description 用户取消
               */
              _this2.$store.dispatch('video_controller/_cancelCall');
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handlerHangupCaller: function handlerHangupCaller() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              /**
               * @description 用户挂断
               */
              _this3.$store.dispatch('video_controller/_hangupCall', true);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handlerHangup: function handlerHangup() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              /**
               * @description 用户挂断
               */
              _this4.$store.dispatch('video_controller/_hangupCall');
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handlerReject: function handlerReject(msg) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              /**
               * @description 拒接
               */
              _this5.$store.dispatch('video_controller/_rejectCall');
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    handlerAccepted: function handlerAccepted() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              /**
               * @description 接听
               */
              _this6.$store.dispatch('video_controller/_acceptCall');
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  }
};

/* script */
const __vue_script__ = script;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.visible
    ? _c(
        "div",
        {
          directives: [{ name: "drag", rawName: "v-drag" }],
          class: _vm.video_box_wrapper,
        },
        [
          _vm.beBusy
            ? [
                _c("img", {
                  staticClass: "shrinkIcon",
                  attrs: { src: _vm.shrinkIcon },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation();
                      return _vm.zoom.apply(null, arguments)
                    },
                  },
                }),
                _vm._v(" "),
                !_vm.shrink
                  ? _c("img", {
                      staticClass: "changeRemote",
                      attrs: { src: _vm.changeRemoteIcon, alt: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation();
                          return _vm.changeRemote.apply(null, arguments)
                        },
                      },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.localContainerClass,
              attrs: { id: "rtc_localContainer" },
            },
            [
              !_vm.beBusy
                ? [_vm.isCaller ? [_vm._m(0)] : [_vm._m(1)]]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", {
            class: _vm.remoteContainerClass,
            attrs: { id: "rtc_remoteContainer" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "call-duration" }, [
            _vm._v(_vm._s(_vm.callDurationStr)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.videoOperate },
            [
              _vm.isCaller
                ? [
                    _vm.beBusy
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "operate-box reject",
                              on: { click: _vm.handlerHangupCaller },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$5,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("挂断")]),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "operate-box reject",
                              on: { click: _vm.handlerCancel },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$5,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("取消")]),
                            ]
                          ),
                        ],
                  ]
                : [
                    _vm.beBusy
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "operate-box reject",
                              on: { click: _vm.handlerHangup },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$5,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("挂断")]),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "operate-box reject",
                              on: { click: _vm.handlerReject },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$5,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("拒绝")]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "operate-box answer",
                              on: { click: _vm.handlerAccepted },
                            },
                            [
                              _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: img$4,
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("接听")]),
                            ]
                          ),
                        ],
                  ],
            ],
            2
          ),
        ],
        2
      )
    : _vm._e()
};
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "video-waiting" }, [
      _c("p", { staticClass: "tip-text" }, [
        _vm._v("\n            呼叫中\n            "),
        _c("span", { staticClass: "dotting" }),
      ]),
    ])
  },
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "video-waiting" }, [
      _c("p", { staticClass: "tip-text" }, [
        _vm._v("\n            接听中\n            "),
        _c("span", { staticClass: "dotting" }),
      ]),
    ])
  },
];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-64b7151b";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__.install = function (Vue) {
  Vue.component(__vue_component__.name, __vue_component__);
};

// console.log('测试下注入');
var components = [__vue_component__$2, __vue_component__$1];

// will install the plugin only once
var install = function install(Vue) {
  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
};
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

// To allow use as module (npm/webpack/etc.) export component
var TRTCModal = __vue_component__$2;
var NETTCV1Modal = __vue_component__$1;
var rtcVideo = __vue_component__;

exports.NETTCV1Modal = NETTCV1Modal;
exports.TRTCModal = TRTCModal;
exports.rtcVideo = rtcVideo;
